var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"breadcrumb has-bullet-separator"},[_c('ul',{staticStyle:{"flex-wrap":"nowrap"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }